var _g, _circle, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M34.6,33.7v0.7l-2.1,0.3l-0.9-1l-0.4-1.6 c0-0.1-0.1-0.2-0.2-0.2l-1.6-0.4L29.1,30c0-0.1,0-0.1-0.1-0.1l-1.6-0.4l-0.4-1.6c0-0.1-0.1-0.2-0.2-0.2l-1.6-0.4l-2.1-2.1l1.3-1.1 l0.3-0.3l-0.2-0.2c-0.1,0-0.1-0.2,0-0.3l-0.4,0.5c-0.5,0.4-1,0.8-1.6,1.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2l2.4,2.4h0.1 l1.6,0.4l0.4,1.6c0,0.1,0,0.2,0.1,0.2l1.6,0.4l0.4,1.7h0.2l1.6,0.4l0.3,1.7h0.1l1.1,1.1h0.2l2.4-0.4l0.1-0.2l0,0v-1.1 c0,0.1,0,0.2-0.1,0.3H34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M23.1,25.2l2.1,2.1l1.6,0.4 c0.1,0,0.2,0.1,0.2,0.2l0.4,1.6l1.6,0.4c0.1,0,0.1,0,0.1,0.1l0.4,1.6l1.6,0.4c0.1,0,0.2,0.1,0.2,0.2l0.4,1.6l0.9,1l2.1-0.3v-0.7 l-10-10L24.4,24L23.1,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M24.4,23.5l0.2,0.2l10,10h0.3 c0.1-0.1,0.1-0.2,0.1-0.3l-0.4-2.2l-9.1-9c0-0.1,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1h-0.2c-0.2,0.4-0.4,0.7-0.7,1 C24.4,23.4,24.4,23.5,24.4,23.5z M25.4,22.7l8.8,8.8l0.2,1.5l-9.5-9.5C25.1,23.2,25.2,22.9,25.4,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#505050",
    strokeWidth: 0.25,
    strokeMiterlimit: 10,
    d: "M24.9,23.5l9.5,9.5l-0.2-1.5l-8.8-8.8 C25.2,22.9,25.1,23.2,24.9,23.5z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#505050",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    cx: 19.4,
    cy: 18.6,
    r: 7.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    stroke: "#505050",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    d: "M16.9,14.2c-1.3,0-2.4,1.1-2.4,2.4 c0,1.3,1.1,2.4,2.4,2.4c1.3,0,2.4-1.1,2.4-2.4C19.4,15.3,18.3,14.2,16.9,14.2z M16.9,18.7c-1.1,0-2-0.9-2-2s0.9-2,2-2 c1.1,0,2,0.9,2,2S18.1,18.7,16.9,18.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#ECECEC",
    stroke: "#505050",
    strokeWidth: 0.3,
    strokeMiterlimit: 10,
    cx: 16.9,
    cy: 16.7,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.530b695d113f8feaa6f83a290ed6ee25.svg";
export { ForwardRef as ReactComponent };